import React from "react";
import styled from "styled-components";

const Wrapper = styled.fieldset`
  border: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`;

const Label = styled.label`
  color: #ffffff;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 5px;
  padding: 0;
`;

const Error = styled.span`
  color: #fe036a;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 0 5px;
  padding: 0;
`;

const Input = styled.input`
  background: #181543;
  border-radius: 8px;
  border: 1px solid ${props => (props.error ? "#fe036a" : "transparent")};
  color: #ffffff;
  font-family: "Lato", sans-serif;
  font-size: 1.125rem;
  height: 56px;
  line-height: 1.5;
  margin: 0 0 20px;
  outline: none;
  padding: 0 17px;
  width: 100%;
`;

const Fieldset = ({
  type,
  id,
  label,
  placeholder,
  error,
  value,
  onChange,
  onBlur
}) => {
  return (
    <Wrapper>
      <Label htmlFor={id}>
        {label}
      </Label>

      <Error>
        {error}
      </Error>

      <Input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        error={error}
      />
    </Wrapper>
  );
};

export default Fieldset;



// WEBPACK FOOTER //
// ./src/components/Fieldset/index.jsx